import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { LogError } from '../../../AppUtil/AppUtil';
import BuxService from '../../../Service/BuxService';
import CashoutService from '../../../Service/CashoutService';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import CashOutAmountForm from './CashOutAmountForm';
import CashOutOtpForm from './CashOutOtpForm';
import { hot } from 'react-hot-loader';

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,
			amount: null,
			payout_uid: '',
			payout_otp: '',
			payout_otp_type: null,
			sub_email: this.props.user.email,
			req_id: uuidv4()
		};
	}

	toggleLoader = () => {
		this.setState({
			_isLoading: !this.state._isLoading
		});
	};

	toastFail = msg => {
		Swal.fire({
			title: 'Error',
			allowOutsideClick: false,

			text: msg,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: 'Try again',
			customClass: 'otp_message_success'
		});
	};

	toaster = msg => {
		Swal.fire({
			allowOutsideClick: false,

			title: 'Info',
			text: msg,
			icon: 'info',
			confirmButtonText: 'OK',
			customClass: 'otp_message_success'
		});
	};

	toasterCashout = msg => {
		Swal.fire({
			title: 'Info',
			text: msg,
			allowOutsideClick: false,
			icon: 'info',
			confirmButtonText: 'OK',
			customClass: 'otp_message_success'
		}).then(res => {
			if (res.value) {
				window.location.href = '/profile';
			}
		});
	};

	onAmountSubmit = cashOutObj => {
		this.setState({
			amount: cashOutObj.amount
		});
	};

	onOtpTypeSubmit = async otpType => {
		try {
			this.toggleLoader();

			// hit the Request Payout OTP API
			const payload = {
				sub_email: this.props.user.email,
				otp_type: otpType
			};
			const response = await BuxService.buxPayoutOtp(payload);
			if (!response || response.status === 'failed') {
				const msg = response.message.includes('Bank account with this ID is not exist')
					? 'Bank account with this ID does not exist'
					: response.message || 'Cash out request failed';
				this.toastFail(msg);
				throw new Error(msg);
			}

			this.setState({
				payout_uid: response.uid,
				payout_otp_type: otpType
			});
			this.toggleLoader();
			this.toaster(this.props.t(`profile.payout_otp_type_${this.state.payout_otp_type}`));
		} catch (err) {
			this.toggleLoader();
			LogError(err);
		}
	};

	cashOutFailed = response => {
		const msg = response.message.includes('Bank account with this ID is not exist')
			? 'Bank account with this ID does not exist'
			: response.message || 'Cash out request failed';
		this.toastFail(msg);
		throw new Error(msg);
	};

	onOtpSubmit = async otp => {
		try {
			this.toggleLoader();

			const payload = {
				req_id: this.state.req_id,
				payout_uid: this.state.payout_uid,
				sub_email: this.props.user.email,
				payout_otp: otp,
				payout_otp_type: this.state.payout_otp_type,
				amount: this.state.amount,
				mode: 'Instapay',
				bank_account_id: this.props.selectedBank.bank_account_id || this.props.user.bank_account_id
			};

			const response = await BuxService.buxPayout(payload);

			if (response?.status === 'success') {
				const payload = {
					req_id: this.state.req_id,
					sub_email: this.props.user.email
				};

				const payout_status = await BuxService.buxPayoutStatus(payload);

				if (payout_status?.payload?.status === 'Failed') {
					this.cashOutFailed(response);
				} else {
					const payloadCashout = {
						wallet_id: this.props.user.email,
						channel: this.props.selectedBank.bank || this.props.user.bank,
						reference_number: this.state.req_id, // req_id
						amount: this.state.amount,
						status: payout_status?.payload?.status
					};

					await CashoutService.create(payloadCashout);
					this.toggleLoader();
					this.toasterCashout(this.props.t('profile.cash_out_info'));
					this.props.closeProfileScreen();
				}
			} else {
				this.cashOutFailed(response);
			}
		} catch (err) {
			this.toggleLoader();
			LogError(err);
		}
	};

	render() {
		const { amount } = this.state;

		return !amount ? (
			<CashOutAmountForm
				closeProfileScreen={this.props.closeProfileScreen}
				isLoading={this.state._isLoading}
				onAmountSubmit={this.onAmountSubmit}
			/>
		) : (
			<CashOutOtpForm
				closeProfileScreen={this.props.closeProfileScreen}
				isLoading={this.state._isLoading}
				payout_otp_type={this.state.payout_otp_type}
				onAmountSubmit={this.onAmountSubmit}
				onOtpTypeSubmit={this.onOtpTypeSubmit}
				onOtpSubmit={this.onOtpSubmit}
			/>
		);
	}
}

export default hot(module)(withStyles(commonStyleForEditPersonalInfo)(withTranslation()(index)));
